import { API } from '@Providers';

interface CalculateCartMedicalCostsParams {
  animal_id: string;
}

export default async function (params: CalculateCartMedicalCostsParams) {
  const baseEndpoint = '/api/shelter/cart/calculate-medical-costs';
  const urlParams = new URLSearchParams();

  urlParams.append('animal_id', params.animal_id);

  const endpoint = urlParams.toString() ? `${baseEndpoint}?${urlParams.toString()}` : baseEndpoint;

  return API({ endpoint, method: 'post' });
}
